import { State } from '..';

interface EventProps {}

interface Config<S, P, A, R, T> {
  attributes?: Partial<A>;
}

const StateNothing = function <S, P extends EventProps, A extends {}, R, T>({
  attributes = {},
}: Config<S, P, A, R, T>): State<S, P, A, R> {
  return {
    onAction: async (args) => {},
    attributes: {
      ...(attributes as any),
    },

    nodeName: 'T.states.nothing',
    outputs: null,
  };
};

export default StateNothing;
